<template>
  <div>
    Editor
    <tinymce id="editor" v-model="editor.text" :options="editor.options" @change="change" :content="editor.content"></tinymce>
    <div class="spacer">
        <button name="button1" class="btn btn-primary" v-on:click="downloadPdf()">Generate PDF</button>
    </div>
    <div class="spacer">
        <div><h3>Debug Details</h3></div>
        <div>
            Base Url: <br/>
            <input name="baseUrl" type="text" class="form-control" v-model="pdfHtmlFileDto.baseUrl" placeholder="Base URL" >
        </div>
        <div class="spacer">
            Header Template:<br/>
            <textarea id="footer" rows="10" style="width: 1024px;" v-model="pdfHtmlFileDto.headerHtml" /><br/>
            Header Output:<br/>
            <div v-html="pdfHtmlFileDto.headerHtml" style="width: 1024px; border: 1px solid black;"></div>
        </div>
        <div class="spacer">
            Footer Template:<br/>
            <textarea id="footer" rows="6" style="width: 1024px;" v-model="pdfHtmlFileDto.footerHtml" /><br/>
            Footer Output:<br/>
            <div v-html="pdfHtmlFileDto.footerHtml" style="width: 1024px; border: 1px solid black;"></div>
        </div>
        <div class="spacer">
            Body Template:<br/>
            <textarea id="footer" rows="6" style="width: 1024px;" v-model="editor.text" /><br/>
        </div>
    </div>
  </div>
</template>

<style>
.spacer {
    padding-top: 30px;
}
</style>

<script>

import loggingService from '@/services/util/loggingService'
import componentService from '@/services/util/componentService'
import mediaService from '@/services/mediaService'

export default {
    name: 'editor',
    data () {
        return {
            isDebug: false,
            pdfHtmlFileDto: {
                baseUrl: 'https://172.26.7.28',
/* eslint-disable no-tabs */
                headerHtml: `<div style="margin: 50px">
  <table width="100%">
	<tr>
		<td style="width: 65%"><img src="/static/ArtsParksHistory.png" width="176" height="77" /></td>
		<td>Wyoming State Historic Preservation Office<br/>2301 Central Ave.<br/>Cheyenne, WY.  82002<br/>307-777-6401</td>
	</tr>
  </table>
</div>`,
                bodyHtml: '',
/* eslint-disable no-tabs */
                footerHtml: `<div style="margin: 50px">
	<img src="/static/ShpoLetterFooter.jpg" style="display: block; margin: auto; width:200px" />
</div>`
            },
            editor: {
                text: 'a - default text',
                content: `<div style="margin: 50px 100px 50px 100px;">
<p>August 11, 2016</p>
<br/>
David Vela, Superintendent<br/>
U.S.D.I. National Park Service<br/>
Grand Teton National Park<br/>
P.O. Drawer 170<br/>
Moose, WY  83012<br/>
<br/>
<p>Re:  Moose-Wilson Corridor Comprehensive Plan for Grand Teton National Park, Letter of July 29, 2016 SHPO File #0214ECK006</p>
<br/>
<p>Dear Mr. Vela,</p>

<p>I want to sincerely thank you and your staff for traveling to Cheyenne to meet with myself,  Richard Currit and Beth King from the State Historic Preservation Office staff, Jerimiah Rieman and Jessica Crowder of Governor Matt Mead’s staff, Sara Needles, Division Administrator for Cultural Resources and  Milward Simpson, Director of Wyoming State Parks and Cultural Resources.  As indicated at our meeting, I am providing you and your staff specific comments and direction on what is needed by our office to provide you with our concurrence on your decision of effect for the Moose-Wilson Corridor proposed by Grand Teton National Park (GTNP).</p>

<p>Our discussions at the meeting and the commitment of GTNP to initiate and engage our office in consultation earlier in the planning process is certainly welcomed.  Compliance with S106 of the National Historic Preservation Act should begin as early in the agencies’ planning process as possible and closure should occur prior to GTNP selecting a final alternative and issuing the decision notice to the public.  We also encourage the engagement of local government, including the local historic preservation board, members of the Alliance for Historic Wyoming, and the National Trust for Historic Preservation in any proposed undertaking developed under the 36CFR § 800 regulations.</p>

<p>We all recognize the mixing of NEPA and NHPA compliance is challenging and I continue to encourage GTNP to follow and implement the guidance found at:  http://www.achp.gov/docs/NEPA_NHPA_Section_106_Handbook_Mar2013.pdf</p>

<p>First of all, I want to provide some guidance on when a letter might be submitted for S106 purposes.   This list is certainly not exhaustive and other circumstances may arise when general correspondence is appropriate:</p>
<ul>
<li>Initiating the S106 process</li>
<li>Requesting consultation on appropriate consulting parties</li>
<li>Documenting a decision of “no potential to cause effect” ? This always falls under the  nPA.</li>
<li>Requesting to segment an undertaking and phase identification efforts</li>
</ul>

<p>Undertakings generally require the submission of documentation of the agencies’ decision which meets the Secretary of Interiors Standards for Archaeology and Historic Preservation</p>

<p>In general, compliance letters are utilized when an agency is requesting concurrence with a determination of WYOMING STATE HISTORIC PRESERVATION OFFICE FORMAT, GUIDELINES, and STANDARDS for CLASS II and III REPORTS</p>
</div>`,
                options: {
                    selector: 'textarea#editor',
                    height: 300,
                    theme: 'modern',
                    toolbar1: 'fontselect',
                    content_css: [
                        '//www.tinymce.com/css/codepen.min.css'
                    ],
                    forced_root_block: ''
                }
            }
        }
    },
    computed: {
        componentName: function () {
            return componentService.getComponentNameDebug(this)
        }
    },
    methods: {
        change: (editor, content) => {
        },
        downloadPdf: function () {
            this.pdfHtmlFileDto.bodyHtml = this.editor.text

            mediaService.getHtmlToPdfFile(this.$http, this.pdfHtmlFileDto).then(function (response) {
                mediaService.saveFileToDownload(response, 'sample.pdf')
            })
        }
    },
    created () {
        loggingService.log(this.isDebug, 'Dashboard', 'mounted')
    },
    mounted () {
        loggingService.log(this.isDebug, 'Dashboard', 'mounted')
    },
    destroyed () {
        loggingService.log(this.isDebug, 'Dashboard', 'mounted')
    }
}

</script>



// WEBPACK FOOTER //
// Editor.vue?7204cccf